import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import Loading from "../components/Loading";


const ProtectedRoute = ({ children,roles = [] }) => {
  const { hasRole, loading } = useAuth();

  // Wait for roles to be restored from localStorage before deciding access,
  // otherwise a refresh briefly sees roles=[] and redirects incorrectly.
  if (loading) {
    return <Loading />;
  }

  // Admin can access everything
  if (hasRole("Admin")) {
    return children;
  }

  // If this route has role restrictions
  if (roles.length > 0) {
    const hasAccess = roles.some((role) => hasRole(role));

    if (!hasAccess) {
      return <Navigate to="/equipment-certificates" replace />;
    }
  }

 
  return children;
};

export default ProtectedRoute;
